export const generatePath = <Root extends string, SubLink extends string>(
  root: Root,
  sublink: SubLink,
) => {
  return `${root}${sublink}` as const;
};
